export enum CapabilityCurveTypeEnum {
  TORQUE = 'torque',
  POWER = 'power',
  ACCELERATION = 'acceleration',
}
